import React, { useState } from "react";
import { Table } from "antd";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import SansadSpeech from "../../assets/pdfs/sansad.pdf"
import { FaFilePdf } from "react-icons/fa"; // ✅ PDF icon

const Result = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const powerBiLinks = user?.powerBiLinks || [];
  const speechFiles = user?.speechFiles || []; // Store uploaded PDFs here
  const navigate = useNavigate();

  const dummySpeechFiles = [
    {
      title: "Independence Day Speech",
      fileUrl: SansadSpeech, // Replace with your PDF link
      description: "Speech delivered on Independence Day.",
    }
  ];

  const speechColumns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
     {
    title: "File",
    dataIndex: "fileUrl",
    key: "fileUrl",
    render: () => (
      <FaFilePdf size={22} color="red" />
    ),
  },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
  ];

  const handlePowerBiRowClick = (record, index) => {
    navigate(`/powerbi-module/${index}`, { state: record });
  };

  const handleSpeechRowClick = (record, index) => {
    navigate(`/speech-module/${index}`, { state: record });
  };

  return (
    <>
      <ToastContainer />
      <div className="reports-section">
        <div className="page-heading" style={{ marginTop: "2rem" }}>
          <h3>Speech Reports (PDF)</h3>
        </div>
        <Table
          dataSource={dummySpeechFiles}
          columns={speechColumns}
          rowKey={(record, index) => index}
          onRow={(record, index) => ({
            onClick: () => handleSpeechRowClick(record, index),
            style: { cursor: "pointer" },
          })}
          pagination={true}
        />
      </div>
    </>
  );
};

export default Result;
